﻿
export class LoginModel {
    username: string;
    password: string;
    rememberMe: boolean;
    errorMessage: string;
    isHeaderNameRequired: boolean;
    showSpinner:boolean;
}